
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/[uuid]",
      function () {
        return require("private-next-pages/signup/[uuid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signup/[uuid]"])
      });
    }
  